import React from "react";

function TestimonialCard({ name, role, avatar, rating, review }) {
  const stars = Array.from({ length: 5 }, (_, i) => (i < rating ? "★" : "☆"));

  return (
    <div className="testimonial-card">
      <div className="testimonial-quote">"</div>

      <p className="testimonial-review">{review}</p>

      <div className="testimonial-stars">
        {stars.map((star, i) => (
          <span key={i} className={`star ${i < rating ? "filled" : ""}`}>{star}</span>
        ))}
      </div>

      <div className="testimonial-author">
        <div className="testimonial-avatar">{avatar}</div>
        <div className="testimonial-info">
          <h4>{name}</h4>
          <span>{role}</span>
        </div>
      </div>
    </div>
  );
}

export default TestimonialCard;
